import { styled } from 'styled-components';

import { styleBodyM, styleLabelM, styleLabelS } from 'style/components/Typography';
import { MQ } from 'style/mediaQueries';

export const Wrapper = styled.div`
    display: flex;
    flex-flow: column wrap;
    justify-content: flex-start;
    row-gap: 0.875rem;

    ${MQ.FROM_M} {
        row-gap: 1.3125rem;
        grid-area: form;
        grid-column: col-start 7 / span 6;
    }

    ${MQ.FROM_XL} {
        row-gap: 1.75rem;
        grid-column: col-start 7 / span 5;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-flow: column wrap;
    row-gap: 2.1875rem;
    width: 100%;

    ${MQ.FROM_M} {
        row-gap: 2.625rem;
    }

    ${MQ.FROM_XL} {
        row-gap: 3.5rem;
    }

    dl {
        display: grid;
        column-gap: 0;
        border-top: 1px solid var(--line-on-neutral-default);
        grid-gap: 0;
        grid-template-columns: 1fr 1fr;

        dt,
        dd {
            margin-left: 0;
            border: none;
            border-bottom: 1px solid var(--line-on-neutral-default);
            padding: 1.75rem;
            color: var(--text-on-neutral-primary);
            line-height: 1;
            text-align: left;
        }

        dt {
            ${styleLabelS};
            padding-left: 0;
        }

        dd {
            ${styleBodyM};
            padding-right: 0;

            ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    margin-bottom: 0.875rem;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
`;

export const Heading = styled.h3`
    ${styleLabelM};
    margin: 0;
`;
